<template>
  <div>
    <v-card>
      <v-card-title>
        กรอกคะแนน GAT PAT
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selected_year_id"
          v-bind:label="$t('officer_config.academic_year')"
          v-bind:items="filtered_years"
          v-bind:item-value="(item) => item.YEAR_ID"
          v-bind:item-text="(item) => item.SEMESTER + ' / ' + item.YEAR"
          outlined
          dense
          @change="update_year(selected_year_id)"
        ></v-autocomplete>

        <v-autocomplete
          v-if="selected_year_id !== null"
          v-model="selected_round_id"
          :label="$t('program_list.round')"
          :items="rounds"
          :item-value="(item) => item.ROUND_ID"
          :item-text="(item) => objectTranslator(item, 'NAME')"
          outlined
          dense
          @change="update_round(selected_round_id)"
        ></v-autocomplete>

        <v-autocomplete
          v-if="selected_year_id !== null"
          v-model="selected_registrar_faculty_id"
          :label="$t('officer_config.faculty')"
          :items="registrar_faculties"
          :item-value="(item) => item.FACULTY_ID"
          :item-text="(item) => objectTranslator(item, 'FACULTY_NAME')"
          outlined
          dense
        ></v-autocomplete>

        <v-divider></v-divider>

        <div v-if="selected_round_id !== null">
          <div>
            <v-simple-table
              class="mb-5"
              max-height="300px"
            >
              <template v-slot:default>
                <thead class="blue-grey darken-1">
                  <tr>
                    <th
                      class="text-left white--text font-weight-light"
                      style="width: 500px;"
                      rowspan="2"
                    >
                      {{ $t("number_of_applicants_report.curriculum") }}
                    </th>
                    <th class="text-center white--text font-weight-light">
                      จำนวนรับ
                    </th>
                    <th class="text-center white--text font-weight-light">
                      GAT (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      GAT1 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      GAT2 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      PAT1 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      PAT2 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      PAT3 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      PAT4 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      PAT5 (%)
                    </th>
                    <th class="text-center white--text font-weight-light">
                      PAT6 (%)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template>
                    <tr
                      v-for="item in filtered_gat_pat_data"
                      :key="item.CURRICULUM_ID"
                    >
                      <td class="text-left">
                        {{ objectTranslator(item, "CURRICULUM_SHORT_NAME") }}
                        <span
                          v-if="item.BRANCH_NAME_TH"
                          class="deep-orange--text"
                        >
                          {{ $t("number_of_applicants_by_order_report.branch") }}
                          {{ objectTranslator(item, "BRANCH_NAME") }}</span>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.QUOTA"
                          @input="item.QUOTA = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.GAT_WEIGHT"
                          @input="item.GAT_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.GAT_1_WEIGHT"
                          @input="item.GAT_1_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.GAT_2_WEIGHT"
                          @input="item.GAT_2_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.PAT_1_WEIGHT"
                          @input="item.PAT_1_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.PAT_2_WEIGHT"
                          @input="item.PAT_2_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.PAT_3_WEIGHT"
                          @input="item.PAT_3_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.PAT_4_WEIGHT"
                          @input="item.PAT_4_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.PAT_5_WEIGHT"
                          @input="item.PAT_5_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          dense
                          hide-details
                          outlined
                          v-model="item.PAT_6_WEIGHT"
                          @input="item.PAT_6_WEIGHT = $event !== '' ? $event : null"
                        ></v-text-field>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider class="mt-5 mb-1 pt-5"></v-divider>
            <v-btn
              color="green"
              dark
              @click="save()"
            >
              SAVE
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { objectTranslator } from "@/helper/translator";

import FacultyProvider from "@/services/faculty.provider";
const facultyService = new FacultyProvider();

import ConfigProvider from "@/services/config.provider";
const configService = new ConfigProvider();

export default {
  name: "CurriculumConfigGatPat",
  props: {
    level_id: {
      type: String,
      default: "1",
    },
  },
  data: () => ({
    loading: false,
    rounds: null,
    gat_pat_data: [],

    selected_year_id: null,
    selected_registrar_faculty_id: null,
    selected_round_id: null,
    registrar_faculties: [],
  }),
  computed: {
    filtered_years() {
      return this.$store.state.officerConfig.config_years.filter(
        (item) => item.LEVEL_ID === this.level_id
      );
    },

    filtered_gat_pat_data() {
      if (
        this.selected_round_id === null ||
        this.selected_registrar_faculty_id === null ||
        this.gat_pat_data.length === 0
      )
        return [];

      return this.gat_pat_data.filter(
        (i) => i.MASTER_REG_FACULTY_ID === this.selected_registrar_faculty_id
      );
    },
  },
  methods: {
    objectTranslator,

    async update_year(year_id) {
      this.selected_round_id = null;
      this.selected_registrar_faculty_id = null;
      await this.fetch_ref_data(year_id);
    },

    async update_round(round_id) {
      this.loading = true;
      const data = await configService.getGatPatCriteria(round_id);
      // === map CURRICULUM_ID กับ ADMISSION_CURRICULUM_ID ให้ back ไม่ได้ทำไว้ เลยไม่ได้ส่งมา
      this.gat_pat_data = data.map((i) => ({
        ...i,
        ADMISSION_CURRICULUM_ID: i.CURRICULUM_ID,
      }));
      this.loading = false;
    },

    async fetch_ref_data(year_id) {
      this.loading = true;
      const rounds = await configService.getFilteredRounds({ year_id });
      this.rounds = rounds;

      if (this.registrar_faculties.length == 0) {
        const faculties = await facultyService.getFaculties();
        this.registrar_faculties = faculties;
      }
      this.loading = false;
    },

    async save() {
      this.loading = true;
      const response = await configService
        .saveGatPatCriteria(this.filtered_gat_pat_data)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.loading = false;
    },
  },
  created: function () {
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>

<style scoped>
th {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
td {
  overflow: hidden;
  white-space: nowrap;
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
</style>